// Meal type constants

export const MEAL_TYPES = ['Breakfast', 'Lunch', 'Dinner', 'Snack', 'Add On'];

export const DELIVERY_DAYS = {
    MONDAY: 1,
    TUESDAY: 2,
    THURSDAY: 4,
    SUNDAY: 0
};

export const LOCK_HOURS = {
    MONDAY_DELIVERY: 12, // 12 PM EST on Saturday
    TUESDAY_DELIVERY: 12, // 12 PM EST on Saturday
    THURSDAY_DELIVERY: 12, // 12 PM EST on Tuesday
    SUNDAY_DELIVERY: 20, // 8 PM EST on Friday
    OTHER_DELIVERY: 12 // 12 PM EST on Thursday
};

export const CARD_CONFIG = {
    WIDTH: 280,
    GAP: 15
};

export const MEAL_PRICES = {
    'Breakfast': 12.99,
    'Lunch': 19.99,
    'Dinner': 23.99,
    'Snack': 5.99
};

export const SUBSCRIPTION_DISCOUNT = 0.9;

export const PREMIUM_SURCHARGE = 4; // $4 per meal for premium plans

// Bulk pricing for add-on items: keyword in dish name → { single, bulkEach, bulkMin }
export const BULK_PRICING = {
    smoothie: { single: 14.99, bulkEach: 11.99, bulkMin: 3 },
    latte: { single: 14.99, bulkEach: 11.99, bulkMin: 3 },
    shot: { single: 8.99, bulkEach: 6.99, bulkMin: 3 }
};

// Returns the bulk pricing category for a dish name, or null if none
export const getBulkCategory = (dishName) => {
    const words = (dishName || '').toLowerCase().trim().split(/\s+/);
    if (words.includes('pack')) return null;
    for (const keyword of Object.keys(BULK_PRICING)) {
        if (words.includes(keyword)) return keyword;
    }
    return null;
};